import axios from "axios";


export function createAccount(data) {
	return async dispatch => new Promise(async function(resolve, reject) {
		try {
			// dispatch({ type: "LOG_USER_START", payload: "" });
			console.log('[INFO],createAccount,logUser,  data',{ data });

			const res = await axios.post("/account/new", data);
			console.log('[INFO],createAccount,logUser,  info',{ res });

			resolve("ook");
		} catch (err) {
			console.log("[ERROR] login action ", err);
			return err;
		}
	});
}



